import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import _ from 'lodash';
import { inputUniversalLocale } from '@/components/air/search-inputs/src/input-universal/locales';
import { commonLocale } from './common'

export function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage()
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages: {
            ...inputUniversalLocale,
            ...commonLocale,
        },
    })
}
export const i18n = createI18nInstance()

export async function loadI18n(targetLang?: string) {
    const lang = targetLang || getCurrentLanguage()
    let results;
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/cn.json'),
            import('CommonMessages/eureka-common-country/cn.json'),
            import('CommonMessages/eureka-common-errorcode/cn.json'),
            import('CommonMessages/eureka-air/cn.json'),
            import ('element-plus/es/locale/lang/zh-cn')
        ])
    }
    if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/en.json'),
            import('CommonMessages/eureka-common-country/en.json'),
            import('CommonMessages/eureka-common-errorcode/en.json'),
            import('CommonMessages/eureka-air/en.json'),
            import ('element-plus/es/locale/lang/en')
        ])
    }
    if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/jp.json'),
            import('CommonMessages/eureka-common-country/jp.json'),
            import('CommonMessages/eureka-common-errorcode/jp.json'),
            import('CommonMessages/eureka-air/jp.json'),
            import ('element-plus/es/locale/lang/ja')
        ])
    }
    if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/eureka-common-product/tw.json'),
            import('CommonMessages/eureka-common-country/tw.json'),
            import('CommonMessages/eureka-common-errorcode/tw.json'),
            import('CommonMessages/eureka-air/tw.json'),
            import ('element-plus/es/locale/lang/zh-tw')
        ])
    }

    const data = results?.reduce((obj, { default: data }) => {
        return _.merge(obj, data);
    }, {});

    if (data) {
        i18n.global.mergeLocaleMessage(lang, data);
    }
    return i18n;
}
